import { useState, useEffect } from 'react';
import { useBackendSettings } from './useBackendSettings';

export const useProjectPlayerTour = () => {
  const [showTour, setShowTour] = useState(false);
  const { settings, saveSettings, isLoading: isLoadingSettings } = useBackendSettings();

  useEffect(() => {
    // Wait for settings to load from backend before deciding whether to show tour
    if (isLoadingSettings) {
      return;
    }

    // Check if user has completed the tour
    const hasCompletedTour = settings?.player_tour_completed === 'true';
    
    // Show tour automatically if never completed
    if (!hasCompletedTour) {
      setShowTour(true);
    } else {
      setShowTour(false);
    }
  }, [settings, isLoadingSettings]);

  const completeTour = () => {
    saveSettings({ 
      player_tour_completed: 'true',
      player_tour_skipped: 'false' 
    });
    setShowTour(false);
  };

  const skipTour = () => {
    // Mark as skipped but not completed, so badge can show
    saveSettings({ player_tour_skipped: 'true' });
    setShowTour(false);
  };

  const resetTour = () => {
    saveSettings({ 
      player_tour_completed: 'false',
      player_tour_skipped: 'false'
    });
    setShowTour(true);
  };

  // Check if tour was skipped but never completed (for badge indicator)
  const wasSkipped = settings?.player_tour_skipped === 'true' && 
                     settings?.player_tour_completed !== 'true';

  return {
    showTour,
    isLoading: isLoadingSettings,
    completeTour,
    skipTour,
    resetTour,
    wasSkipped,
  };
};
